<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="3">
          <v-select
            :items="groupByItems"
            item-text="text"
            item-value="value"
            label="Group By"
            v-model="selectedGroupBy"
          ></v-select>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="3">
          <v-select
            :items="orderByItems"
            item-text="text"
            item-value="value"
            label="Order By"
            v-model="selectedOrderBy"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3" sm="6" xs="12" :class="classPadding">
          <custom-datepicker
            :class-padding="classPadding"
            label="Date From"
            v-model="dateFrom"
          ></custom-datepicker>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12" :class="classPadding">
          <custom-datepicker
            :class-padding="classPadding"
            label="Date To"
            v-model="dateTo"
          ></custom-datepicker>
        </v-col>
      </v-row>
      <pay-loc-selection
        :show-dense="false"
        :headers="payLocHeaders"
        :show-select="true"
        v-model="payLoc"
        :by-user="true"
      ></pay-loc-selection>
      <br />
      <v-card :class="classPadding">
        <v-card-title>
          <span class="caption">Select Fields</span>
        </v-card-title>
        <v-card-text>
          <v-row> 
            <v-col cols="12" xs="12" sm="12" md="12" class="pa-0 ma-0">
              <v-checkbox
                label="Check/Clear All"
                :class="classPadding"
                v-model="checkAll"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
              <v-checkbox
                label="1. Present Address"
                :class="classPadding"
                v-model="itemSelected"
                value="PAddress"
              ></v-checkbox>
              <v-checkbox
                label="2. Mobile Phone no. /s"
                :class="classPadding"
                v-model="itemSelected"
                value="MobilePhone"
              ></v-checkbox>
              <v-checkbox
                label="3. Date of Birth"
                :class="classPadding"
                v-model="itemSelected"
                value="DOB"
              ></v-checkbox>
              <v-checkbox
                label="4. Gender"
                :class="classPadding"
                v-model="itemSelected"
                value="Gender"
              ></v-checkbox>
              <v-checkbox
                label="5. Citizenship"
                :class="classPadding"
                v-model="itemSelected"
                value="Citizenship"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
              <v-checkbox
                label="6. Civil Status"
                :class="classPadding"
                v-model="itemSelected"
                value="CivilStatus"
              ></v-checkbox>
              <v-checkbox
                label="7. TIN No."
                :class="classPadding"
                v-model="itemSelected"
                value="TIN"
              ></v-checkbox>
              <v-checkbox
                label="8. SSS No."
                :class="classPadding"
                v-model="itemSelected"
                value="SSS"
              ></v-checkbox>
              <v-checkbox
                label="9. Pag Ibig No."
                :class="classPadding"
                v-model="itemSelected"
                value="PagIbig"
              ></v-checkbox>
              <v-checkbox
                label="10. Philhealth No."
                :class="classPadding"
                v-model="itemSelected"
                value="Philhealth"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
              <v-checkbox
                label="11. Email Address"
                :class="classPadding"
                v-model="itemSelected"
                value="Email"
              ></v-checkbox>
              <v-checkbox
                label="12. Date Hired"
                :class="classPadding"
                v-model="itemSelected"
                value="DateHired"
              ></v-checkbox>
              <v-checkbox
                label="13. Payroll Location"
                :class="classPadding"
                v-model="itemSelected"
                value="PayrollLocation"
              ></v-checkbox>
              <v-checkbox
                label="14. Designation"
                :class="classPadding"
                v-model="itemSelected"
                value="Designation"
              ></v-checkbox>
              <v-checkbox
                label="15. Tax Code"
                :class="classPadding"
                v-model="itemSelected"
                value="TaxCode"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
              <v-checkbox
                label="16. Basic Salary"
                :class="classPadding"
                v-model="itemSelected"
                value="BasicSalary"
              ></v-checkbox>
              <v-checkbox
                label="17. Allowance"
                :class="classPadding"
                v-model="itemSelected"
                value="Allowance"
              ></v-checkbox>
              <v-checkbox
                label="18. Date of Expiration of NBI Clearance"
                :class="classPadding"
                v-model="itemSelected"
                value="DOE-NBI"
              ></v-checkbox>
              <v-checkbox
                label="19. Date of Expiration of Driver's License"
                :class="classPadding"
                v-model="itemSelected"
                value="DOE-DRIVERS"
              ></v-checkbox>
              <v-checkbox
                label="20. Status"
                :class="classPadding"
                v-model="itemSelected"
                value="Status"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-row>
        <v-col xs="12" sm="12" md="12">
          <v-btn
            outlined
            @click.stop="exportReport"
            :loading="loading"
            :class="classPadding"
            >Export</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import moment from "moment"
const CustomDatepicker = () => import("../../../components/CustomDatepicker");
const PayLocSelection = () =>
  import("../../setup/general/payroll-location/NewSelection");
const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    groupByItems: [
      { text: "Payroll Location", value: "Payroll Location" },
      { text: "Department", value: "Department" },
    ],
    orderByItems: [
      { text: "Employee Code", value: "EmpCode" },
      { text: "Employee Name", value: "LName" },
    ],
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId",
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName",
      },
    ],
    payLoc: [],
    dateFrom: null,
    dateTo: null,
    model: {},
    loading: false,
    checkAll: false,
    itemSelected: [],
    selectedGroupBy: "",
    selectedOrderBy: ""
  }),
  components: {
    CustomDatepicker,
    PayLocSelection,
  },
  computed: {
    countSelected() {
      // let i = 0;
      // for (var key of Object.keys(this.model)) {
      //   // console.log(key + " -> " + this.model[key]);
      //   if (this.model[key]) i++;
      // }
      // return i;
      return this.itemSelected.length;
    },
    // itemSelected() {
    //   var items = []

    //   if(this.model.presentAddress){
    //     var value = "PAddress";
    //     if(items.indexOf("PAddress") === -1){
    //       items.push(value);
    //     } 
    //   }else {
    //     var index = items.indexOf("PAddress");
    //     items.splice(index, 1);
    //   }

    //   if(this.model.mobileNo){
    //     var value = "MobilePhone";
    //     if(items.indexOf("MobilePhone") === -1){
    //       items.push(value);
    //     } 
    //   }else {
    //     var index = items.indexOf("MobilePhone");
    //     items.splice(index, 1);
    //   }

    //   return items;
    // }
  },
  methods: {
    exportReport() {
      this.loading = true;
      var param = {
        Grp: this.grp,
        GroupBy: this.selectedGroupBy,
        OrderBy: this.selectedOrderBy,
        DateFrom: moment(this.dateFrom).format("MM/DD/YYYY"),
        DateTo: moment(this.dateTo).format("MM/DD/YYYY"),
        SelectedField: this.itemSelected.toString()
      };
      var url = `${API_ENDPOINT}/list-emp-w-selected-fields`;
      //   if (this.group2 == "0") {
      //     url = `${API_ENDPOINT}/emp-sem-train-recomm`;
      //   } else if (this.group2 == "1") {
      //     url = `${API_ENDPOINT}/employment-info`;
      //   } else if (this.group2 == "2" || this.group2 == "3") {
      //     url = `${API_ENDPOINT}/emp-other-info`;
      //   }

      this.$axios
        .post(url, param)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;

          window.open(
            `${subPath.slice(0, -1)}/report-viewer?reportCode=${
              data.reportDto.reportCode
            }&dbName=${data.reportDto.dbName}&key=${data.reportDto.key}&companyKey=${
              data.reportDto.companyKey
            }&reportUrl=${data.reportDto.url}&client=${data.reportDto.client}&logoAlign=${
              data.reportDto.logoAlign
            }&logoWidth=${data.reportDto.logoWidth}&rpt=${data.reportDto.rpt}`
          );
          var fieldGroup = data.selectedCount;
          if((fieldGroup[7]) | (fieldGroup[8]) | (fieldGroup[9]) | (fieldGroup[10]) | (fieldGroup[11]) | (fieldGroup[12]) | (fieldGroup[13])){
              this.$axios
                .post(`${url}2`, param)
                .then((response ) => {
                  var item = response.data;
                  window.open(
                    `${subPath.slice(0, -1)}/report-viewer?reportCode=${
                      item.reportCode
                    }&dbName=${item.dbName}&key=${item.key}&companyKey=${
                      item.companyKey
                    }&reportUrl=${item.url}&client=${item.client}&logoAlign=${
                      item.logoAlign
                    }&logoWidth=${item.logoWidth}&rpt=${item.rpt}`
                  );
                }).catch(({ response }) => {
                  this.$toast.error(response.data.message);
                })
          }
          if((fieldGroup[14]) | (fieldGroup[15]) | (fieldGroup[16]) | (fieldGroup[17]) | (fieldGroup[18]) | (fieldGroup[19])){
             this.$axios
                .post(`${url}3`, param)
                .then((response ) => {
                  var item = response.data;
                  window.open(
                    `${subPath.slice(0, -1)}/report-viewer?reportCode=${
                      item.reportCode
                    }&dbName=${item.dbName}&key=${item.key}&companyKey=${
                      item.companyKey
                    }&reportUrl=${item.url}&client=${item.client}&logoAlign=${
                      item.logoAlign
                    }&logoWidth=${item.logoWidth}&rpt=${item.rpt}`
                  );
                }).catch(({ response }) => {
                  this.$toast.error(response.data.message);
                })
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    checkAll(val) {
      if (val) {
       this.itemSelected = ["PAddress","MobilePhone","DOB","Gender","Citizenship","Philhealth","PagIbig","SSS","TIN","CivilStatus","Email","DateHired","PayrollLocation","Designation","TaxCode","Status","DOE-DRIVERS","DOE-NBI","Allowance","BasicSalary"]
      } else {
        if (this.countSelected < 20) {
          //this.checkAll == false;
        } else {
          this.itemSelected = []
        }
      }
    },
    countSelected(val) {
      if (val < 20) {
        this.checkAll = false;
      } else {
        this.checkAll = true;
      }
    },
  },
};
</script>
